'use client';

import { Carousel } from 'react-bootstrap';
import Image from 'next/image';
import Link from 'next/link';
import './herocarousel.scss';
import { urlForImage } from '@/sanity/lib/utils';

interface CarouselItem {
  imageSrc: string;
  linkHref: string;
  altText?: string;
  blurDataURL?: string;
}

interface CarouselProps {
  items: CarouselItem[];
}

const CustomCarousel: React.FC<CarouselProps> = ({ items }) => {
  return (
    <Carousel
      indicators={false}
      controls={false}
      interval={3000}
      slide={false}
      fade={true}
      pause="hover"
    >
      {items.map((item, index) => (
        <Carousel.Item key={index}>
          {item?.linkHref ? (
            <Link href={item.linkHref}>
              <Image
                src={urlForImage(item.imageSrc)?.url() as string}
                alt={item.altText || 'Carousel image'}
                className="d-inline-block"
                width={460}
                height={606}
                quality={100}
                sizes="100vw"
                priority
                placeholder="blur"
                blurDataURL={item.blurDataURL}
              />
            </Link>
          ) : (
            <Image
              src={urlForImage(item.imageSrc)?.url() as string}
              alt={item.altText || 'Carousel image'}
              className="d-inline-block"
              width={460}
              height={606}
              quality={100}
              sizes="100vw"
              priority
              placeholder="blur"
              blurDataURL={item.blurDataURL}
            />
          )}
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default CustomCarousel;
